export default __webpack_public_path__ + "static/media/Soulwatch Hood.1cbd8968.jpg";